import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
// import { gsapBreakpoints } from './breakpoints'

export const revealOnLoad = ({ callback = () => {}, delay = 0, duration = 0.765, ease = 'power3.out', selectors }): void => {
  if (!selectors) {
    return
  }

  gsap.registerPlugin(ScrollTrigger)

  const defaultProps = {
    from: { opacity: 0, y: 32 },
    to: { clearProps: 'all', duration, ease, opacity: 1, y: 0 },
  }

  const visibleItems = []
  const stagger = 0.05

  document.querySelectorAll(selectors).forEach((item) => {
    if (ScrollTrigger.isInViewport(item)) {
      visibleItems.push(item)
    }
  })

  visibleItems.forEach((item, index) => {
    if (ScrollTrigger.isInViewport(item)) {
      gsap.killTweensOf(item)
      gsap.set(item, defaultProps.from)
      gsap.fromTo(item, defaultProps.from, { delay: delay + stagger * index, ...defaultProps.to })
    }
  })

  setTimeout(callback, (delay + duration) * 1000 + 123 + (visibleItems.length - 1) * stagger * 1000)
}

export const revealOnScroll = ({
  delayOnEnter = 0,
  delayOnLeaveBack = delayOnEnter / 2,
  durationOnEnter = 0.765,
  durationOnLeaveBack = 0.543,
  easeOnEnter = 'power3.out',
  easeOnLeaveBack = easeOnEnter,
  item,
  onEnterStart = '0% 90%',
  // onEnterStartMobile = '0% 90%-=100px',
  onEnterStartCallback = () => {},
  onLeaveBackStart = '0% 100%+=32px',
  // onLeaveBackStartMobile = '0% 100%-=100px',
  onLeaveBackStartCallback = () => {},
  propsFrom = {},
  propsTo = {},
  trigger = item,
  visibleOnLoadIfInView = true,
}): void => {
  if (!item) {
    return
  }

  gsap.registerPlugin(ScrollTrigger)

  const defaultProps = {
    from: { opacity: 0, y: 32 },
    to: { opacity: 1, y: 0 },
  }

  const checkIfInViewport = (el) => {
    if ((ScrollTrigger.isInViewport(el) && !visibleOnLoadIfInView) || !ScrollTrigger.isInViewport(el)) {
      gsap.set(el, { ...defaultProps.from, ...propsFrom })
    }
  }

  if (typeof item === 'object' && item.length) {
    item.forEach((el) => {
      checkIfInViewport(el)
    })
  } else {
    checkIfInViewport(item)
  }

  // gsap.matchMedia().add(gsapBreakpoints, (context) => {
  //   const is = context.conditions

  ScrollTrigger.create({
    onEnter: () => {
      gsap.killTweensOf(item)
      gsap.to(item, {
        clearProps: 'all',
        delay: delayOnEnter,
        duration: durationOnEnter,
        ease: easeOnEnter,
        onStart: onEnterStartCallback,
        ...defaultProps.to,
        ...propsTo,
      })
    },
    // start: is.mobile || is.tablet ? onEnterStartMobile : onEnterStart,
    start: onEnterStart,
    trigger: trigger || item,
  })

  ScrollTrigger.create({
    onLeaveBack: () => {
      gsap.to(item, {
        delay: delayOnLeaveBack,
        duration: durationOnLeaveBack,
        ease: easeOnLeaveBack,
        onStart: onLeaveBackStartCallback,
        overwrite: true,
        ...defaultProps.from,
        ...propsFrom,
      })
    },
    // start: is.mobile || is.tablet ? onLeaveBackStartMobile : onLeaveBackStart,
    start: onLeaveBackStart,
    trigger: trigger || item,
  })
  // })
}
